import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/homePage/index.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/productPage/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/aboutPage/index.vue')
  },
  {
    path: '/question',
    name: 'question',
    component: () => import('@/views/questionPage/index.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/accountPage/index.vue')
  },
  {
    path: '/politica',
    name: 'politica',
    component: () => import('@/views/politicaPage/index.vue')
  },
  {
    path: '/terminos',
    name: 'terminos',
    component: () => import('@/views/terminosPage/index.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
